import { render } from "./RecentWinners.vue?vue&type=template&id=77fc3c5f"
import script from "./RecentWinners.vue?vue&type=script&lang=js"
export * from "./RecentWinners.vue?vue&type=script&lang=js"

import "./RecentWinners.vue?vue&type=style&index=0&id=77fc3c5f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__